var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.count),function(n){return _c('div',{key:n,staticClass:"skeleton-list-item",style:({ height: _vm.itemHeight })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }